module.exports = __webpack_public_path__ + "img/icon_win.7ed31571.png";